<template>
    <div>
        <table>
            <tr>
                <td><p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="normal">normal</p-radio></td>
            </tr>
            <tr>
                <td><p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="tara">tare</p-radio></td>
            </tr>
            <tr>
                <td><p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="gross">gross</p-radio></td>
            </tr>
        </table>
    </div>
</template>

<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
    },
    props: [
    ],
    data: function(){return{
        
    }},
    beforeMount: function(){
        console.log('beforemount in weighing.vue', this.value, this.settings)
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample','SnapvialSample']);
        //Vue.set(this.settings, 'outputType', 'SnapvialSample');

        this.setDefault('mode', 'normal');
        
    }
}

</script>

<style lang="scss">
</style>

<style lang="scss" src="./action.scss" scoped />